// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_c8-j";
export var fulfillmentFormRail = "_c8-i";
export var headerTitleRow = "_c8-l";
export var orderDetailsWrapper = "_c8-g";
export var orderLinkTrigger = "_c8-2";
export var paymentInformationGrid = "_c8-q";
export var paymentSummaryColumn = "_c8-r";
export var phoneShipmentPickerButton = "_c8-e";
export var phoneShipmentPickerButtonContent = "_c8-f";
export var phoneShipmentPickerButtonWrapper = "_c8-d";
export var phoneShipmentPickerTrigger = "_c8-c";
export var shipmentContainer = "_c8-k";
export var shipmentDetailsMainPane = "_c8-h";
export var shipmentNavigationCard = "_c8-a";
export var shipmentNavigationEdgeTrigger = "_c8-6";
export var shipmentNavigationRail = "_c8-3";
export var shipmentNavigationRailEnter = "_c8-5";
export var shipmentNavigationRailHeader = "_c8-9";
export var shipmentNavigationRailOverlay = "_c8-4";
export var shipmentNavigationScrim = "_c8-7";
export var shipmentSummaryFact = "_c8-n";
export var shipmentSummaryGrid = "_c8-m";
export var shipmentSummaryMetadataRow = "_c8-o";
export var shipmentSummaryTags = "_c8-p";
export var shipmentWorkspace = "_c8-0";
export var shipmentWorkspaceBodyTablet = "_c8-8";
export var shipmentWorkspaceContent = "_c8-b";
export var shipmentWorkspaceHeader = "_c8-1";